import { format } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

export const ageFormatter = (date) => {
    if (!date) return '--';

    const NOW = new Date();
    const diffInMs = NOW.getTime() - new Date(date).getTime();
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
    return `${diffInDays} days`;
};

export const dateFormatter = (date, params) => {
    if (params?.tz) {
        return date ? formatInTimeZone(new Date(date), params.tz, 'EEE, MMM d, yyyy') : '--';
    }

    return date ? format(new Date(date), 'EEE, MMM d, yyyy') : '--';
};

export const timeFormatter = (date, params) => {
    if (params?.tz) {
        return date ? formatInTimeZone(new Date(date), params.tz, 'h:mm a') : '--';
    }

    return date ? format(new Date(date), 'h:mm a') : '--';
};

export const currencyFormatter = (amount) => {
    return amount ? `$${amount.toFixed(2)}` : '--';
};
